import { State, Author } from '@/types'
import { Store } from 'vuex'
import { createVerifyResult, applyValidationResults, validateField } from './utils'

export default async function validateAuthorInfoView(store: Store<State>) {
  const verifyResult = createVerifyResult('Authors')

  const validationResults = await Promise.all([
    validateField(store.state.activeSubmission.authors, 'at-least-one-author-required'),
    validateField(store.state.activeSubmission.authors, 'all-authors-must-be-valid'),
  ])

  applyValidationResults(validationResults, verifyResult)

  verifyResult.valid = verifyResult.errors.length === 0
  store.commit('setVerifyResult', {
    key: 'authorInfoVerifyResult',
    verifyResult,
  })
}

export function authorValidate(author: Author): boolean {
  return !!author.firstName.length
    && !!author.lastName.length
    && !!author.email.length
    && !!author.affiliation?.city
    && !!author.affiliation?.name
    && !!author.affiliation?.country
}

export function validateWithOtherAuthors(author: Author, index: number, allAuthors: Author[]): boolean {
  return authorValidate(author)
    && validateWithPreviousAuthorsEmail(author, index, allAuthors)
}
export function validateWithPreviousAuthorsEmail(author: Author, index: number, allAuthors: Author[]): boolean {
  return !allAuthors.slice(0, index).filter(auth => auth.email === author.email).length
}
